// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import * as echarts from 'echarts'
import 'echarts-gl'
import App from './App'
import store from './store'
import router from './router'
import VueResource from 'vue-resource'
import ElementUI, { Table } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import globalVariable from './api/global'
import moment from 'moment'
import VueContextMenu from 'vue-contextmenu'
import localForage from 'localforage/src/localforage'
import pinyin from 'js-pinyin'
// import 'default-passive-events'
import bus from './utils/bus'
import 'codemirror/lib/codemirror.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import './style/var.css'

// ElementUI.Dialog.props.lockScroll.default = false

Vue.use(VXETable)

Vue.use(VueContextMenu)
Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.http.options.emulateJSON = true
Vue.config.productionTip = false
// Vue.config.devtools = true
Vue.prototype.GLOBAL = globalVariable
Vue.prototype.axios = axios
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$store = store
Vue.prototype.localForage = localForage
Vue.prototype.pinyin = pinyin
Vue.prototype.bus = bus
Vue.directive('dragform', {
  bind (el, binding, vnode) {}
})
Vue.directive('loadMore', {
  bind (el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    const onScroll = function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight + 10
      if (CONDITION) {
        binding.value()
      }
    }

    SELECTWRAP_DOM.addEventListener('scroll', onScroll)
    el._onScroll = onScroll // 将监听器存储在元素的属性中，以便以后移除
  },
  unbind (el) {
    // 移除滚动事件监听器
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    if (SELECTWRAP_DOM && el._onScroll) {
      SELECTWRAP_DOM.removeEventListener('scroll', el._onScroll)
      delete el._onScroll
    }
  }
})

moment.locale('zh-cn')
const fixElTableErr = (table) => {
  const oldResizeListener = table.methods.resizeListener
  table.methods.resizeListener = function () {
    window.requestAnimationFrame(oldResizeListener.bind(this))
  }
}
// 一定要在Vue.use之前执行此函数
fixElTableErr(Table)

Vue.config.errorHandler = (err, vm, info) => {
  console.error('errorHandle', err, vm, info)
  let item = {err: err}
  let key = 'errorHandle'
  let map = {}

  if (!Array.isArray(this[key])) {
    map[key] = []
  }
  let time = new Date().getTime()
  map[key].unshift(item)
  map[key][0].time = time
  if (map[key].length > 20) {
    map[key].splice(map[key].length - 1, 1)
  }
  localForage.setItem(key, map[key])
}

/* eslint-disable no-new */
window.$Vue = new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js